import { Modal } from '../common/modal';
import { stripTags } from '../../util/text';

export default class ConfirmationModal extends Modal {
    constructor({ copyToUse, callback, triggerElement }) {
        super({
            content: `
                <p>${copyToUse}</p>
                <div class="button-container"></div>`,
            classes: ['ConfirmationModal', 'small'],
            title: stripTags(copyToUse),
            hiddenTitle: true,
            showCloseButton: true,
        });

        const buttonAction = () => {
            if (callback) {
                callback();
            } else {
                this.close();
            }
            if (triggerElement) {
                triggerElement.focus();
            }
        };

        this.$content.find('.button-container').append(`
            <button class="button primary margin-small radius u-allCaps js-close">
                ${html('ok')}
            </button>`);

        this.on('close cancel', () => requestAnimationFrame(buttonAction));
        this.show();
        this.$el.find('.close-reveal-modal').focus();
    }
}
